// @flow

import type { UserSettingsState } from '@alphaott/common-types'

import type { UserSettingsStore } from '../types'

export const getUserSettings = (state: UserSettingsStore): UserSettingsState => state.userSettings
